e<template>
     <div class="container-fluid">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1>Encuestas</h1>
                    </div>
                </div>
            </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-5">
                    <div class="card">
                        <div class="card-header">
                            <div style="display: flex; justify-content: space-between; align-items: center;">
                                <h3 class="card-title">Lisado de encuestas</h3>
                                <div style="display: flex; align-items: center; gap: 15px">
                                    <input class="form-control form-control-sm" v-model="nombreNueva" placeholder="Nombre">
                                    <button class="btn btn-light btn-sm" style="border: 1px solid grey" @click="anadirEncuesta">Añadir</button>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Id</th>
                                        <th>Nombre</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="encuesta in Object.entries(encuestas)" :key="encuesta[0]">
                                        <td>{{ encuesta[0] }}</td>
                                        <td>{{ encuesta[1].nombre_encuesta }}</td>
                                        <td><div style="display: flex; gap: 10px;">
                                            <button class="btn btn-light btn-sm" style="border: 1px solid grey" @click="editarEncuesta(encuesta[1])">Editar</button>
                                            <button class="btn btn-light btn-sm" style="border: 1px solid grey" @click="eliminarEncuesta(encuesta[0])">Eliminar</button>
                                        </div></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
    <Dialog @hide="visibleEditar = false" v-model:visible="visibleEditar"  modal header="Editar encuesta" :style="{width: '1200px'}">
        <div style="display: flex; gap: 10px; align-items: center; justify-content: start; margin-bottom: 25px">
            <input style="width: auto;" class="form-control form-control-sm" v-model="nombreEncuesta">
            <button class="btn btn-sm btn-light" style="border: 1px solid grey" @click="editarNombre">Actualizar nombre</button>
        </div>
        <div style="margin-bottom: 10px; display: flex; justify-content: space-between; gap: 10px">    
            <div></div>        
            <h5>Preguntas</h5>
            <button class="btn btn-sm btn-primary" @click="anadirPregunta">Añadir</button>
        </div>
        <div v-if="preguntasEncuesta.length > 0">            
            <table class="table">
                <thead>
                    <tr>
                        <th>Pregunta</th>
                        <th>Tipo</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="pregunta in preguntasEncuesta" :key="pregunta.id">
                        <td>{{ pregunta.texto }}</td>
                        <td>{{ pregunta.tipo }}</td>
                        <td><div style="display: flex; gap: 10px;">
                            <button class="btn btn-light btn-sm" style="border: 1px solid grey" @click="editarPregunta(pregunta)">Editar</button>
                            <button class="btn btn-light btn-sm" style="border: 1px solid grey" @click="eliminarPregunta(pregunta.id)">Eliminar</button>
                        </div></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div v-if="preguntaNueva">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Nueva pregunta</h3>
                </div>
                <div class="card-body">
                    <div style="display: grid; gap: 15px;">
                        <div>
                            <label for="">Pregunta</label>
                            <textarea v-model="textoPreguntaNueva" placeholder="Pregunta" class="form-control"></textarea>
                        </div>
                        <div>
                            <label for="">Tipo</label>
                            <select v-model="tipoPreguntaNueva" class="form-control">
                                <option value="">----</option>
                                <option value="Puntuación">Puntuación</option>
                                <option value="Respuestas">Respuestas</option>
                                <option value="Texto">Texto</option>
                            </select>
                        </div>
                        <div v-if="tipoPreguntaNueva == 'Puntuación'">
                            <label for="">Puntuación</label>
                            <div style="display: flex;gap: 10px; align-items: center;">
                                <label style="margin:0" for="">Min</label>
                                <input type="number" v-model="minPuntuacionNueva" class="form-control form-control-sm">
                                <label style="margin:0" for="">Max</label>
                                <input type="number" v-model="maxPuntuacionNueva" class="form-control form-control-sm">
                            </div>
                        </div>
                        <div v-if="tipoPreguntaNueva == 'Respuestas'">
                            <label for="">Respuestas</label>
                            <input style="margin-bottom: 10px;" class="form-control" type="text" v-for="num in numRespuestas" :key="num" v-model="respuestaNueva[num]">
                            <button class="btn btn-sm btn-light" style="border: 1px solid grey" @click="numRespuestas++">Añadir respuesta</button>
                        </div>
                        <div style="display: flex;">
                            <button style="width: auto;" class="btn btn-sm btn-primary" @click="crearPregunta">Guardar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="preguntaEditar">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Editar pregunta</h3>
                </div>
                <div class="card-body">
                    <div style="display: grid; gap: 15px;">
                        <div>
                            <label for="">Pregunta</label>
                            <textarea v-model="textoPreguntaEditar" placeholder="Pregunta" class="form-control"></textarea>
                        </div>
                        <div>
                            <label for="">Tipo</label>
                            <select v-model="tipoPreguntaEditar" class="form-control">
                                <option value="">----</option>
                                <option value="Puntuación">Puntuación</option>
                                <option value="Respuestas">Respuestas</option>
                                <option value="Texto">Texto</option>
                            </select>
                        </div>
                        <div v-if="tipoPreguntaEditar == 'Puntuación'">
                            <label for="">Puntuación</label>
                            <div style="display: flex;gap: 10px; align-items: center;">
                                <label style="margin:0" for="">Min</label>
                                <input type="number" v-model="minPuntuacionEditar" class="form-control form-control-sm">
                                <label style="margin:0" for="">Max</label>
                                <input type="number" v-model="maxPuntuacionEditar" class="form-control form-control-sm">
                            </div>
                        </div>
                        <div v-if="tipoPreguntaEditar == 'Respuestas'">
                            <label for="">Respuestas</label>
                            <input style="margin-bottom: 10px;" class="form-control" type="text" v-for="num in numRespuestasEditar" :key="num" v-model="respuestaEditar[num-1]" :placeholder="'Respuesta ' + num">
                            <button class="btn btn-sm btn-light" style="border: 1px solid grey" @click="numRespuestasEditar++">Añadir respuesta</button>
                        </div>
                        <div style="display: flex;">
                            <button style="width: auto;" class="btn btn-sm btn-primary" @click="confirmarEditarPregunta">Guardar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import { PwgsApi } from '../../../../services/PwgsApi';
export default ({
    components: {
        Dialog,
    },
    props: [],
    data() {
        return {
            preguntaAEditar:'',
            encuestas: '',
            nombreNueva:'',
            visibleEditar:false,
            preguntaEditar:false,
            preguntasEncuesta: [],
            encuestaEditar:'',
            nombreEncuesta:'',
            preguntaNueva:false,
            textoPreguntaNueva:'',
            tipoPreguntaNueva:'',
            minPuntuacionNueva:0,
            maxPuntuacionNueva:0,
            numRespuestas:1,
            respuestaNueva:[],
            textoPreguntaEditar:'',
            tipoPreguntaEditar:'',
            minPuntuacionEditar:0,
            maxPuntuacionEditar:0,
            numRespuestasEditar:1,
            respuestaEditar:[],
        }
    },
    methods: {
        async confirmarEditarPregunta(){
            const api = new PwgsApi();
            try{
                await api.put('encuestas/'+this.encuestaEditar.id_encuesta+'/preguntas/'+this.preguntaAEditar.id, {
                    pregunta: this.textoPreguntaEditar,
                    tipo_pregunta: this.tipoPreguntaEditar,
                    puntuacion_minima: this.minPuntuacionEditar,
                    puntuacion_maxima: this.maxPuntuacionEditar,
                    respuestas: this.respuestaEditar
                });
                this.cargarEncuestas();
                this.preguntaEditar=false;
                this.editarEncuesta(this.encuestaEditar);
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async crearPregunta(){
            const api = new PwgsApi();
            try{
                await api.post('encuestas/'+this.encuestaEditar.id_encuesta+'/preguntas', {
                    pregunta: this.textoPreguntaNueva,
                    tipo_pregunta: this.tipoPreguntaNueva,
                    puntuacion_minima: this.minPuntuacionNueva,
                    puntuacion_maxima: this.maxPuntuacionNueva,
                    respuestas: this.respuestaNueva
                });
                this.cargarEncuestas();
                this.anadirPregunta();
                this.editarEncuesta(this.encuestaEditar);
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        }, 
        editarPregunta(pregunta){           
            this.preguntaNueva = false;
            this.preguntaAEditar = pregunta;
            this.textoPreguntaEditar = pregunta.texto;
            this.tipoPreguntaEditar = pregunta.tipo;
            if(pregunta.tipo == 'Puntuación'){
                this.minPuntuacionEditar = parseInt(pregunta.valores[0]);
                this.maxPuntuacionEditar = parseInt(pregunta.valores[1]);
            }
            if(pregunta.tipo == 'Respuestas'){
                this.numRespuestasEditar = pregunta.valores.length;
                this.respuestaEditar = pregunta.valores;
            }
            this.preguntaEditar = true;            
        },
        anadirPregunta(){
            if(this.preguntaNueva == false){
                this.preguntaEditar = false;
                this.preguntaNueva = true;
            }else{
                this.preguntaNueva = false;
                this.textoPreguntaNueva = '';
                this.tipoPreguntaNueva = '';
                this.minPuntuacionNueva = 0;
                this.maxPuntuacionNueva = 0;
                this.numRespuestas = 1;
                this.respuestaNueva = [];
            }
        },
        async editarNombre(){
            if(this.nombreEncuesta == ''){
                alert('Debes introducir un nombre para la encuesta');
                return;
            }
            const api = new PwgsApi();
            try{
                await api.put('encuestas/' + this.encuestaEditar.id_encuesta, {nombre_encuesta: this.nombreEncuesta});
                this.cargarEncuestas();                
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async eliminarPregunta(id){
            const api = new PwgsApi();
            try{
                await api.delete('encuestas/' + this.encuestaEditar.id_encuesta + '/preguntas/' + id);
                this.$toast.add({ severity: 'success', summary: 'Eliminada', detail: 'Pregunta eliminada', life: 2000 });
                this.editarEncuesta(this.encuestaEditar);
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async editarEncuesta(encuesta){
            const api = new PwgsApi();
            var pregs = await api.get('encuestas/' + encuesta.id_encuesta + '/preguntas');
            this.preguntasEncuesta = pregs;
            this.encuestaEditar = encuesta;
            this.nombreEncuesta = encuesta.nombre_encuesta;
            this.visibleEditar = true;
        },
        async eliminarEncuesta(id){
            const api = new PwgsApi();
            try{
                await api.delete('encuestas/' + id);
                this.$toast.add({ severity: 'success', summary: 'Eliminada', detail: 'Encuesta eliminada', life: 2000 });
                this.cargarEncuestas();
            }catch(e){
                this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
            }
        },
        async anadirEncuesta() {
          if(this.nombreNueva == ''){
            alert('Debes introducir un nombre para la encuesta');
            return;
          }  
          const api = new PwgsApi();
          try{
              await api.post('encuestas', {nombre_encuesta: this.nombreNueva});
              this.cargarEncuestas();
              this.nombreNueva = '';
              this.$toast.add({ severity: 'success', summary: 'Añadida', detail: 'Encuesta añadida', life: 2000 });
          }catch(e){
              this.$toast.add({ severity: 'error', summary: 'Error', detail: e, life: 5000 });
          }
        },
        async cargarEncuestas() {
            const api = new PwgsApi();
            this.encuestas = await api.get('encuestas');
        },
    },
    mounted() {
        this.cargarEncuestas();
    },
})
</script>
<style scoped>
.card-header::after {
    display: none;
}
</style>